enum DeleteMachineConstants {
  CLOSE_DELETE_MACHINE_MODAL = '@DeleteMachine/CLOSE_DELETE_MACHINE_MODAL',
  DELETE_MACHINE = '@DeleteMachine/DELETE_MACHINE',
  DELETE_MACHINE_REQUEST = '@DeleteMachine/DELETE_MACHINE_REQUEST',
  DELETE_MACHINE_REQUEST_SUCCESS = '@DeleteMachine/DELETE_MACHINE_REQUEST_SUCCESS',
  DELETE_MACHINE_REQUEST_ERROR = '@DeleteMachine/DELETE_MACHINE_REQUEST_ERROR',
  OPEN_DELETE_MACHINE_MODAL = '@DeleteMachine/OPEN_DELETE_MACHINE_MODAL',
}

export default DeleteMachineConstants;
